/**
 * @flow
 * @relayHash 1981151e73bc6ac2d8ca12d8b77f4b5e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PeopleList_viewer$ref = any;
export type queries_PeopleList_QueryVariables = {||};
export type queries_PeopleList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PeopleList_viewer$ref
  |}
|};
export type queries_PeopleList_Query = {|
  variables: queries_PeopleList_QueryVariables,
  response: queries_PeopleList_QueryResponse,
|};
*/


/*
query queries_PeopleList_Query {
  viewer {
    ...PeopleList_viewer
    id
  }
}

fragment PeopleList_viewer on Viewer {
  persons(first: -1) {
    edges {
      node {
        id
        ...PeopleListItem_person
      }
    }
  }
}

fragment PeopleListItem_person on Person {
  id
  firstName
  lastName
  personType
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_PeopleList_Query",
  "id": null,
  "text": "query queries_PeopleList_Query {\n  viewer {\n    ...PeopleList_viewer\n    id\n  }\n}\n\nfragment PeopleList_viewer on Viewer {\n  persons(first: -1) {\n    edges {\n      node {\n        id\n        ...PeopleListItem_person\n      }\n    }\n  }\n}\n\nfragment PeopleListItem_person on Person {\n  id\n  firstName\n  lastName\n  personType\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_PeopleList_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PeopleList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_PeopleList_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "persons",
            "storageKey": "persons(first:-1)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              }
            ],
            "concreteType": "PersonConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PersonEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Person",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "personType",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cffcadb8a02b53992526c5c609381c0e';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_PeopleList_Query.graphql.js